module.exports = __webpack_public_path__ + "assets/img/main-logo-qinhuangdao.7e9088c1.png";